import React from 'react';

import { Layout } from '@components/Layout';
import { BookingCreateFormComplete } from '@components/utilities/BookingInquiry/BookingCreateFormComplete';
import { Container } from '@components/utilities/BookingInquiry/Container';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '予約申込',
  },
});

export const Complete: React.FC = () => {
  return (
    <Layout
      title={strings.title}
      breadcrumbs={['/utilities/Dashboard', '/utilities/BookingInquiry/Complete']}
    >
      <Container>
        <BookingCreateFormComplete />
      </Container>
    </Layout>
  );
};
